import Section from '@components/Section/Section';
import { Confirm } from '~/components/Confirm/';
import ButtonBack from '@components/ButtonBack/ButtonBack';
import { ConfirmProvider } from '@components/Confirm';

const ConfirmPage = () => (
    <ConfirmProvider>
        <Section>
            <ButtonBack />
            <Confirm />
        </Section>    
    </ConfirmProvider>
);

export default ConfirmPage;
